import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-4e1d4bae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "l-wrapper_nav"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "l-wrapper_nav" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "p-apply_nav" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-apply_button" }, "一括で応募する", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "p-apply_nav" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-apply_button" }, "応募しない", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "p-recommend-footer_container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "recommend-footer",
  class: "p-recommend-form__send-area"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  class: "p-recommend-form__send-area",
  id: "footer-resume-form"
}
const _hoisted_19 = { class: "g-nav" }
const _hoisted_20 = { class: "g-menu js-gMenu" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ホーム", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "応募管理", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "求人一覧", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "気になる", -1))
const _hoisted_25 = ["aria-expanded"]
const _hoisted_26 = ["aria-hidden"]
const _hoisted_27 = { class: "g-menu-content_inner" }
const _hoisted_28 = { class: "g-menu-content_item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "g-menu-content_heading" }, "職務経歴書・履歴書", -1))
const _hoisted_30 = { class: "g-menu-content_buttonWrap" }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"g-menu-content_item\" data-v-4e1d4bae><p class=\"g-menu-content_heading\" data-v-4e1d4bae>ヘルプ</p><div class=\"g-menu-content_buttonWrap\" data-v-4e1d4bae><a class=\"g-menu-content_button\" href=\"https://mynavi-agent.jp/pdf/agent_mypage_guide_v2.pdf?d=20251217\" target=\"_blank\" data-v-4e1d4bae>マイページの使い方</a><a class=\"g-menu-content_button\" href=\"https://mynavi-agent.jp/service/faq/mynavi/?_ga=2.102996160.1911803075.1728259978-1320162464.1723186724\" target=\"_blank\" data-v-4e1d4bae>FAQ</a></div></div>", 1)
const _hoisted_32 = { class: "g-menu-content_item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "g-menu-content_heading" }, "設定", -1))
const _hoisted_34 = { class: "g-menu-content_buttonWrap" }
const _hoisted_35 = { class: "g-menu-content_item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "g-menu-content_heading" }, "転職ノウハウ", -1))
const _hoisted_37 = { class: "g-menu-content_buttonWrap" }
const _hoisted_38 = { class: "g-menu-content_item -full" }
const _hoisted_39 = ["aria-hidden"]
const _hoisted_40 = { class: "g-menu-logout_inner" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "g-menu-logout_heading" }, "ログアウトしますか？", -1))
const _hoisted_42 = ["onClick"]

import { eventBus } from '@/events/eventBus';
import { useRoute, useRouter } from 'vue-router';
import { postAuthLogout } from '@/api/accountEndpoint';
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { domHelperUtils } from '@/utils/domHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterMyPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();

const menuButtonRef = ref<HTMLElement | null>(null);
const menuContentRef = ref<HTMLElement | null>(null);

const menuOpen = ref(false);
const showLogoutConfirmDialog = ref(false);

// Route-based computed for hiding/showing footer
// const isResumeForm = computed(() => route.path === '2/resume/form/');

// Menu config for highlighting
const menuConfig = [
    { path: ['news'], class: '-home' },
    { path: ['apply'], class: '-id' },
    { path: ['jobsearch', 'refusallist'], class: '-search' },
    { path: ['pending'], class: '-fav' },
    { path: ['profile', 'recommend', 'resume', 'sendsetting', 'pwupdate', 'video'], class: '-menu' },
];

// Which menu is currently active?
const activeMenuClass = computed(() => {
    const pathArr = route.path.split('/');
    if (!pathArr[1]) return '-home';
    if (pathArr[1] === 'apply' && (pathArr[2] === 'form' || pathArr[2] === 'multiple')) {
        return '';
    }
    
    const found = menuConfig.find(cfg => cfg.path.includes(pathArr[1]));
    return found ? found.class : '';
});

// Menu button text
const menuButtonText = computed(() => menuOpen.value ? 'とじる' : 'メニュー');


// Toggle menu open/close logic
const toggleMenu = () => {
    if (showLogoutConfirmDialog.value) return;
    menuOpen.value = !menuOpen.value;
    document.body.style.overflow = menuOpen.value ? 'hidden' : '';
    if (!menuOpen.value && menuButtonRef.value) {
        menuButtonRef.value.focus();
    }
};

// Footer actions
const handleApply = () => {
    eventBus.emit('click-apply-event', 'ACTIVE');
};
const handleRefusal = () => {
    eventBus.emit('click-refusal-event', 'ACTIVE');
};

// Scroll to top function
const scrollToTop = () => {
    domHelperUtils.scrollToTop();
};

// Logout
const logout = async () => {
    try {
        await postAuthLogout();
        store.dispatch('careerId/clear');
        store.dispatch('mailSecurity/clear');
        store.dispatch('mailSecurity/clearHomePopupDismissed');
        store.commit('router/initLoginTransitionData');
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'logout',
                career_id: undefined
            });
        }
        router.push({ name: 'a10' });
    } catch (error) {
        console.error(error);
    }
};

// Click inside the menu content: close menu if link's href matches current path
const handleMenuContentClick = (event: MouseEvent) => {
    let el = event.target as HTMLElement | null;
    while (el && el !== menuContentRef.value) {
        if (el.tagName === 'A' && el.classList.contains('g-menu-content_button')) {
            const href = el.getAttribute('href');
            if (href === window.location.pathname) {
                menuOpen.value = false;
                document.body.style.overflow = '';
                break;
            }
        }
        el = el.parentElement;
    }
};

// Watch for route changes: close menu/logout dialog
watch(() => route.fullPath, () => {
    menuOpen.value = false;
    showLogoutConfirmDialog.value = false;
    document.body.style.overflow = '';
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ((_unref(route).name == 'g01' || _unref(route).name == 'g00' ) && _unref(route).meta.header == 'jobsearch-sp-none')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", {
            class: "g-pagetop_sp",
            href: "#",
            onClick: _withModifiers(scrollToTop, ["prevent"]),
            "aria-label": "ページトップへ戻る"
          }, _hoisted_4, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createElementVNode("a", {
        class: "g-pagetop_sp",
        href: "#",
        onClick: _withModifiers(scrollToTop, ["prevent"]),
        "aria-label": "ページトップへ戻る"
      }, _hoisted_8, 8, _hoisted_6),
      _withDirectives(_createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", { class: "p-apply_button-wrap" }, [
          _createElementVNode("button", {
            class: "u-modal-open-button",
            type: "button",
            onClick: handleApply
          }, _hoisted_11)
        ])
      ], 512), [
        [_vShow, _unref(route).meta.footer === 'applymulti']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", { class: "p-apply_button-wrap" }, [
          _createElementVNode("button", {
            class: "u-modal-open-button",
            type: "button",
            onClick: handleRefusal
          }, _hoisted_14)
        ])
      ], 512), [
        [_vShow, _unref(route).meta.footer === 'refusalmulti']
      ]),
      _createElementVNode("div", _hoisted_15, [
        _withDirectives(_createElementVNode("div", null, _hoisted_17, 512), [
          [_vShow, _unref(route).meta.footer === 'recommendform']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_18, null, 512), [
          [_vShow, _unref(route).name === 'c01']
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["u-lg-hidden", { 'u-lg-recommend_form': (_unref(route).meta.footer === 'recommendform' || _unref(route).name === 'c01') }])
      }, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("nav", _hoisted_20, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["g-menu_button -home", { 'is-active': _unref(activeMenuClass) === '-home' }]),
              to: "/"
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              class: _normalizeClass(["g-menu_button -id", { 'is-active': _unref(activeMenuClass) === '-id' }]),
              to: "/apply/"
            }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              class: _normalizeClass(["g-menu_button -search", { 'is-active': _unref(activeMenuClass) === '-search' }]),
              to: "/jobsearch/"
            }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              class: _normalizeClass(["g-menu_button -fav", { 'is-active': _unref(activeMenuClass) === '-fav' }]),
              to: "/pending/"
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            }, 8, ["class"]),
            _createElementVNode("button", {
              ref_key: "menuButtonRef",
              ref: menuButtonRef,
              class: _normalizeClass(["g-menu_button -menu js-gMenu-button js-gMenu-button-foot", { 'is-active': _unref(activeMenuClass) === '-menu' }]),
              "aria-expanded": menuOpen.value,
              "aria-controls": "g-menu-foot",
              onClick: toggleMenu
            }, [
              _createElementVNode("span", null, _toDisplayString(_unref(menuButtonText)), 1)
            ], 10, _hoisted_25),
            _withDirectives(_createElementVNode("div", {
              ref_key: "menuContentRef",
              ref: menuContentRef,
              class: "g-menu-content js-gMenu-content",
              id: "g-menu-foot",
              "aria-hidden": !menuOpen.value,
              onClick: handleMenuContentClick
            }, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_router_link, {
                      class: "g-menu-content_button",
                      to: "/resume/"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("書類作成")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_router_link, {
                      class: "g-menu-content_button",
                      to: "/sendsetting/"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("配信設定")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      class: "g-menu-content_button",
                      to: "/pwupdate/form/"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("パスワード更新")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      class: "g-menu-content_button",
                      to: "/mail_security/form"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("ログインID・メールアドレス変更")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_router_link, {
                      class: "g-menu-content_button",
                      to: "/video/"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("転職活動ノウハウ動画")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("button", {
                    class: "g-menu-content_button -logout js-gMenu-logout-button",
                    "aria-controls": "g-menu-logout-foot",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showLogoutConfirmDialog.value = true))
                  }, " ログアウト ")
                ])
              ])
            ], 8, _hoisted_26), [
              [_vShow, menuOpen.value]
            ]),
            _withDirectives(_createElementVNode("div", {
              class: "g-menu-logout js-gMenu-logout-content",
              id: "g-menu-logout-foot",
              "aria-hidden": !showLogoutConfirmDialog.value
            }, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("button", {
                  class: "g-menu-logout_close",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showLogoutConfirmDialog.value = false)),
                  "aria-label": "キャンセル"
                }),
                _hoisted_41,
                _createElementVNode("button", {
                  onClick: _withModifiers(logout, ["stop"]),
                  class: "g-menu-logout_button"
                }, "ログアウトする", 8, _hoisted_42),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showLogoutConfirmDialog.value = false)),
                  class: "g-menu-logout_cancel"
                }, "キャンセル")
              ])
            ], 8, _hoisted_39), [
              [_vShow, showLogoutConfirmDialog.value]
            ])
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, _unref(route).meta.header !== 'jobsearch-sp-none']
    ])
  ], 64))
}
}

})